import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/adjustmentcomment/";

export default class AdjustmentCommentApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getAdjustmentComments(params) {
    return await request.post(`${rootRoute}getAdjustmentComments`, {
      filter: params,
      parameters: {},
    });
  }
  async getAdjustmentComment(id) {
    return await request.post(`${rootRoute}getAdjustmentComments`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async getAdjustmentCommentsByAdjustmentId(data) {
    return await request.post(`${rootRoute}getAdjustmentComments`, {
      filter: `$filter=AdjustmentId eq ${data.adjustmentId} and adjustmentMarsPeriodId eq ${data.periodId}&$orderby=createdAt asc`,
      parameters: {},
    });
  }
  async createAdjustmentComment(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createAdjustmentComment`, { data });
  }
  async createAdjustmentComments(models) {
    const data = models;
    return await request.post(`${rootRoute}createAdjustmentComment`, { data });
  }
  async deleteAdjustmentComment(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteAdjustmentComment`, { data });
  }
  async editAdjustmentComment(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAdjustmentComment`, { data });
  }
}
